<template>
  <section class="about section" id="about">
    <h2 class="section-title">{{ $t('about.title') }}</h2>
    <div class="about-container bd-grid">
      <div class="about-img">
        <img :src="require('@/assets/logo.png')" alt="Equipo Invextia">
      </div>
      <div>
        <h2 class="about-subtitle">{{ $t('about.subtitle') }}</h2>
        <span class="about-profession">{{ $t('about.byline') }}</span>
        <p class="about-text" v-html="$t('about.body1')"></p>
        <p class="about-text" v-html="$t('about.body2')"></p>
        <div class="about-social">
          <a href="#" class="about-social-icon" aria-label="LinkedIn"><i class='bx bxl-linkedin'></i></a>
          <a href="#" class="about-social-icon" aria-label="GitHub"><i class='bx bxl-github'></i></a>
          <a href="#" class="about-social-icon" aria-label="Instagram"><i class='bx bxl-instagram'></i></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import sr from '@/scrollreveal.js';

export default {
  name: 'AboutSection',
  mounted() {
    sr.reveal('.about-img', { delay: 300 });
    sr.reveal('.about-subtitle', { delay: 200 });
    sr.reveal('.about-profession', { delay: 300 });
    sr.reveal('.about-text', { delay: 400 });
    sr.reveal('.about-social-icon', { delay: 500, interval: 150 });
  }
};
</script>

<style src="@/styles/About-Section.css"></style>
